<script lang="ts">
  import { Github } from "lucide-svelte";

  import { analytics } from "$lib/analytics";

  export let scriptPath: string;

  $: url = scriptPath.startsWith("http")
    ? scriptPath
    : "https://github.com/modal-labs/modal-examples/blob/main/" + scriptPath;
</script>

<div class="docs-github-button">
  <a
    on:click={() => {
      analytics.track("Example Link Clicked", {
        path: scriptPath,
      });
    }}
    class="btn btn-outlined bg-c-gray-5"
    href={url}
    target="_blank"
    rel="noopener noreferrer"
  >
    <Github size={14} class="mr-2.5 text-c-gray-80" />
    <span class="text-sm text-c-gray-80">View on GitHub</span>
  </a>
</div>
